import React from 'react';
import Grade from './Grade'


 
export default class HospitalRating extends React.Component {

  render() {

    const showText = ((this.props.showText !== undefined) ? this.props.showText : true);

    return (
        <div> 
            {(showText) && (
              <h5><b>{this.props.rating.FriendlyDescription }</b></h5>
            )}
            <Grade grade={this.props.rating.Rating}  />
        </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/Components/HospitalRating.js